import React, { useEffect, useRef } from 'react';
const ReactComment = (props) => {
    const el = useRef();
    useEffect(() => {
        var _a;
        // @ts-ignore
        (_a = el.current) === null || _a === void 0 ? void 0 : _a.outerHTML = `<!-- ${props.text} -->`;
    }, []);
    return React.createElement("div", { ref: el });
};
export default ReactComment;
